import type { CarNumberVariant, CountryOption } from '../model'

export const pinnedCountries = ['BLR', 'AZE', 'CHN', 'KAZ', 'MNG', 'UZB']

export const pinnedOrder = new Map(pinnedCountries.map((code, index) => [code, index]))

export const defaultNumberVariants: CountryOption[] = [
    {
        excludeFromAlphabet: true,
        id: 'RUS_STANDARD',
        label: 'Номер РФ',
        pinned: true,
    },
    {
        excludeFromAlphabet: true,
        id: 'RUS_NON_STANDARD',
        label: 'Нестандартный номер РФ',
        pinned: true,
    },
]

export const carNumberVariantSet = new Set<CarNumberVariant>([
    'OTHER',
    'RUS_NON_STANDARD',
    'RUS_STANDARD',
])

export const ALLOWED_CHARACTERS_MESSAGE =
    'Номер может включать только латинские и кириллические буквы, цифры, пробелы, тире, дефис, знак минуса'
